import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["option"];
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
export const AvailabilityValueComponent = _ref => {
  let {
      option
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Flex, Object.assign({
    alignItems: "center"
  }, props, {
    children: option.dropdownText
  }));
};
AvailabilityValueComponent.displayName = 'AvailabilityValueComponent';